import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';

export const Spinner = ({ children, size = 30 }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress color="primary" size={size} />
      {children && children}
    </Box>
  );
};

Spinner.propTypes = {
  children: PropTypes.node,
  size: PropTypes.number,
};
